export const FETCH_INVOICE_DATA_REQUEST = "FETCH_INVOICE_DATA_REQUEST";
export const FETCH_INVOICE_DATA_SUCCESS = "FETCH_INVOICE_DATA_SUCCESS";
export const FETCH_INVOICE_DATA_FAILURE = "FETCH_INVOICE_DATA_FAILURE";
